'use client';
import { ButtonLinkPrimary } from '@/shared/components/features/buttons/ButtonLinkPrimary';
import { ButtonLinkSecondary } from '@/shared/components/features/buttons/ButtonLinkSecondary';
import { Spacer } from '@/shared/components/parts/Spacer';
import { ListFilter } from './ListFilter';
import { PurchasedList } from './PurchasedList';
import { useMyLibraryUrlParams } from './_hooks/useMyLibraryUrlParams';
import type { CampaignBanner } from '../_resources/getCampaignData';

export const MyLibrary: React.FC<{
  campaignBannerList: CampaignBanner[];
}> = ({ campaignBannerList }) => {
  const { currentPageNo } = useMyLibraryUrlParams();
  return (
    <div className="tw-w-full-space tw-max-w-[60rem]">
      <Spacer level={3} />
      <div className="tw-grid tw-max-w-[60rem] tw-grid-cols-1 tw-gap-[0.5rem] tablet:tw-grid-cols-2">
        <div>
          <ButtonLinkPrimary
            href="/entry/flow"
            text="購入したシリアルコードの登録"
            icon="add"
          />
        </div>
        <div>
          <ButtonLinkSecondary
            href="https://www.amazon.co.jp/b?node=5378643051"
            text="Amazonで他の動画を探す"
            icon="amazon"
            target="_blank"
          />
        </div>
      </div>
      {currentPageNo === 1 && campaignBannerList.length > 0 && (
        <>
          <Spacer level={3} />
          <div className="tw-rounded-4 tw-bg-brand-lv3 tw-p-[1rem]">
            <div className="tw-mx-auto tw-max-w-[30rem] ">
              <div className="tw-text-h5">セール情報</div>
              <Spacer level={0.5} />
              <div className="tw-grid tw-grid-cols-1 tw-gap-[1rem]">
                {campaignBannerList.map(
                  (
                    { large_banner_url, small_banner_url, target_url },
                    index
                  ) => (
                    <div key={index}>
                      <a
                        href={target_url}
                        target="_blank"
                        rel="noreferrer"
                        className="tw-relative tw-block tw-overflow-hidden tw-rounded-4 tw-bg-brand-lv3 tw-shadow-sm tw-shadow-main-10"
                      >
                        <img
                          src={large_banner_url}
                          alt=""
                          className="tw-relative tw-hidden tw-aspect-[50/11] tw-h-full tw-w-full tw-object-cover tablet:tw-block"
                        />
                        <img
                          src={small_banner_url}
                          alt=""
                          className="tw-relative tw-aspect-[16/5] tw-h-full tw-w-full tw-object-cover tablet:tw-hidden"
                        />
                        <div className="tw-absolute tw-inset-0" />
                      </a>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </>
      )}
      <Spacer level={4} />
      <div className="tw-text-h2">購入済み作品</div>
      <Spacer level={1} />
      <ListFilter />
      <Spacer level={1} />
      <PurchasedList />
      <Spacer level={4} />
    </div>
  );
};
